import type { TFunction } from "i18next";

export function genreSlug(genre: string): string {
  return genre
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function translateGenre(t: TFunction, genre: string): string {
  return t(`genre.${genreSlug(genre)}`, { defaultValue: genre });
}

export function normalizeCoverUrl(url: string): string {
  if (url.includes("covers.openlibrary.org") && !url.includes("?")) {
    return `${url}?default=false`;
  }
  return url;
}
